import React from 'react'
import { palettes } from '@manychat/manyui'

import {
  BorderRadius,
  BorderWidth,
  Colors,
  Spacings,
  text,
  textPrimary,
} from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const Button: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: toPx(Spacings.NORMAL),
  borderRadius: toPx(BorderRadius.SMALL),
  padding: `${toPx(Spacings.NORMAL)} 0`,
  border: `${BorderWidth.SMALL} solid ${Colors.BORDER}`,
}

export const ButtonHover: React.CSSProperties = {
  ...Button,
  background: palettes.typography.hover,
}

export const ButtonCaption = { ...text, ...textPrimary }
